import { InjectionToken } from "@angular/core";
import { copyToClipboard } from "@tylertech/forge-core";

/**
 * Wrapping this external function in a Provider so that we can more easily mock
 * it in testing.
 */
export const CopyToClipboardToken = new InjectionToken(
    "CopyToClipboard",
    {
        factory: () => copyToClipboard
    });
